import React, { useEffect } from "react";

import PhotoGallery from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ClientInfoV2/PhotoGallery";
import { useDocumentListStore } from "../../../../../components/modules/Documents/ViewDocuments/hooks/useDocumentListStore";
import Navigation from "../../../../../components/navigations/client/detail/client-info/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service.js";

export default () => {
  const { _case } = useParentLoaderData(2);
  const { setIsUploadModalOpen } = useDocumentListStore();
  const openUploadModal = () => {
    setIsUploadModalOpen(true);
  };

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/client-info/images");
  }, []);

  return (
    <Navigation activeTab="images" _case={_case}>
      <PhotoGallery openUploadModal={openUploadModal} />
    </Navigation>
  );
};
